/**
 * Configuration des URLs pour différents environnements
 */

export const getWebSocketUrl = (): string => {
  // En production, utiliser l'URL de production
  if ((import.meta.env as { MODE?: string }).MODE === 'production') {
    return 'wss://pontcita.conseilcotonanacarde.ci/ws';
  }
  
  // En développement, utiliser l'URL de développement
  return (import.meta.env as any).VITE_WS_URL || 'ws://localhost:8000';
};

export const getApiBaseUrl = (): string => {
  // En production, utiliser l'URL de production
  if ((import.meta.env as { MODE?: string }).MODE === 'production') {
    return 'https://pontcita.conseilcotonanacarde.ci/api/v1';
  }
  
  // En développement, utiliser l'URL de développement
  return (import.meta.env as any).VITE_API_BASE_URL || 'http://localhost:8000/api/v1';
};